import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2 {...{
      "id": "q3-2023-goals"
    }}>{`Q3 2023 Goals`}</h2>
    <ol>
      <li parentName="ol">{`Make CI/CD spark joy`}</li>
    </ol>
    <ul>
      <li parentName="ul">{`Deploying components separately`}</li>
      <li parentName="ul">{`Better controls, allow people to roll back. UI to manage deploy.`}</li>
      <li parentName="ul">{`Make CI faster/have more capacity`}</li>
    </ul>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Empower teams to own their stack`}</li>
    </ol>
    <ul>
      <li parentName="ul">{`Help teams self-serve observability/alerting/paging`}</li>
      <li parentName="ul">{`Give teams insight and control over their costs`}</li>
      <li parentName="ul">{`Help teams figure out how to provision infrastructure`}</li>
    </ul>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`Ongoing maintenance`}</li>
    </ol>
    <ul>
      <li parentName="ul">{`Upgrade Postgres`}</li>
      <li parentName="ul">{`Terraform state/controls`}</li>
      <li parentName="ul">{`Any other interruptions that come up`}</li>
    </ul>
    <h2 {...{
      "id": "roadmap"
    }}>{`Roadmap`}</h2>
    <h4 {...{
      "id": "3-year"
    }}>{`3-year`}</h4>
    <ul>
      <li parentName="ul">{`All infrastructure is managed as code`}</li>
      <li parentName="ul">{`Cloud is global`}</li>
      <li parentName="ul">{`Best in class security and privacy compliance`}</li>
      <li parentName="ul">{`Scale beyond 1 Trillion events / month`}</li>
      <li parentName="ul">{`Support non-k8s Deploys 🤖`}</li>
      <li parentName="ul">{`Painless developer/contributor experience`}</li>
    </ul>
    <h4 {...{
      "id": "6-month"
    }}>{`6 month`}</h4>
    <ul>
      <li parentName="ul">{`No Heroku`}</li>
      <li parentName="ul">{`5 Billion / month events`}</li>
      <li parentName="ul">{`SOC 2 Ready`}</li>
      <li parentName="ul">{`All infra is managed as code on prod / staging + EU Ready 🎈`}</li>
      <li parentName="ul">{`Rock solid, reliable infrastructure with regular production load testing to inform scaling plans`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      